import React from 'react';
import parse from 'html-react-parser';
import { useThrottle } from '@ecs/tng-common/src/scripts/helpers';
// components
import ApplyCardsModal from './cards-apply-modal';
// interfaces
import { ICard } from '../interfaces/cards';

type CardsApplyButtonProps = {
  card: ICard;
  className?: string;
  analyticsPlacement: string;
  text: string;
};
type CardsApplyButtonState = {
  activeApplyCard: ICard | null;
};
class CardsApplyButton extends React.Component<CardsApplyButtonProps, CardsApplyButtonState> {
  constructor(props: CardsApplyButtonProps) {
    super(props);
    this.state = {
      activeApplyCard: null
    };
  }

  seeOffersClick(card: ICard) {
    this.setState({
      activeApplyCard: card
    });
  }

  render() {
    return (
      <>
        <button
          type="button"
          onClick={() => useThrottle(this.seeOffersClick(this.props.card))}
          className={this.props.className}>
          {parse(this.props.text)}
        </button>

        {this.state.activeApplyCard && (
          <ApplyCardsModal
            show
            card={this.state.activeApplyCard}
            analyticsPlacement={this.props.analyticsPlacement}
            onHide={() => {
              this.setState({
                activeApplyCard: null
              });
            }}
          />
        )}
      </>
    );
  }
}

export default CardsApplyButton;
